export async function loadImageFromBlob(blob) {
  if ('createImageBitmap' in window) {
    const image = await createImageBitmap(blob);
    return {
      image,
      width: image.width,
      height: image.height
    };
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve({
        image,
        width: image.naturalWidth,
        height: image.naturalHeight
      });
    };
    image.onerror = e => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    image.src = url;
  });
}